import React, { Component } from "react";
import classes from "./Adminoffers.module.css";
import axios from "axios";
import { connect } from "react-redux";
import Loader from "../../../components/Loader/Loader";
import { setTotalMasterList } from "../../../store/actions/actions";
import plus from "../../../pics/plus.svg";
import { recordToDataBase } from "../../../funcs/funcs";

import { API_URL } from "../../../utils/api";

class Adminoffers extends Component {
  state = {
    offer: "",
    price: "",
    time: "",
    changeOption: "",
  };

  async componentDidMount() {
    //получаем данные из БД
    try {
      const response = await axios.get(`${API_URL}/masters.json`);

      const data =
        response.data[
          Object.keys(response.data)[Object.keys(response.data).length - 1]
        ];

      //записываем данные в Редакс
      this.props.setTotalMasterList(data);

      //удаляем лишние записи
      for (let i = 0; i < Object.keys(response.data).length - 1; i++) {
        await axios.delete(
          `${API_URL}/masters/${Object.keys(response.data)[i]}.json`
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  //обработчик для инпута из добавления (УСЛУГА)
  changeOfferHandlerAdd = (e) => {
    e.preventDefault();

    this.setState({
      offer: e.target.value,
    });
  };

  //обработчик для инпута из добавления (ВРЕМЯ)
  changeTimeHandlerAdd = (e) => {
    e.preventDefault();

    this.setState({
      time: e.target.value,
    });
  };

  //обработчик для инпута из добавления (ЦЕНА)
  changePriceHandlerAdd = (e) => {
    e.preventDefault();

    this.setState({
      price: e.target.value,
    });
  };

  //добавляем услугу в БД
  sendOfferHandler = async (e) => {
    e.preventDefault();

    //собираем нужный текст
    const result = `${this.state.offer}, ${this.state.time}, ${this.state.price}`;

    //создаем массив
    const resultArr = result.split(", ");

    //выключаем услугу по умолчанию
    resultArr.push(false);

    //возвращаем исходное состояние
    this.setState({
      offer: "",
      price: "",
      time: "",
    });

    //клонируем состояние
    const clone = this.props.masterList.slice();

    //итерируем массив и добавляем каждому мастеру услугу
    for (let i = 0; i < clone.length; i++) {
      clone[i][2].push(resultArr);
    }

    //записываем данные в Редакс
    this.props.setTotalMasterList(clone);

    //записываем в БД
    recordToDataBase(this.props.masterList);
  };

  //удаляем услугу из БД
  deleteOfferHandler = async (e) => {
    e.preventDefault();

    //клонируем состояние
    const clone = this.props.masterList.slice();

    //итерируем редакс и добавляем каждому мастеру услугу
    for (let i = 0; i < clone.length; i++) {
      //удаляем
      clone[i][2].splice(e.target.alt, 1);
    }

    //записываем данные в Редакс
    this.props.setTotalMasterList(clone);

    //записываем в БД
    recordToDataBase(this.props.masterList);
  };

  //обработчик редактирования
  changeOfferHandlerEdit = async (e) => {
    e.preventDefault();

    //временное состояние для редактирования
    this.setState({
      changeOption: e.target.value,
    });

    //клонируем состояние
    const clone = this.props.masterList.slice();

    //итерируем редакс и добавляем каждому мастеру услугу
    for (let i = 0; i < clone.length; i++) {
      //редактируем ячейку у каждого мастера
      clone[i][2][e.target.name].splice(e.target.alt, 1, e.target.value);
    }

    //записываем данные в Редакс
    this.props.setTotalMasterList(clone);

    //записываем в БД
    recordToDataBase(this.props.masterList);
  };

  render() {
    return (
      <>
        {this.props.masterList.length === 0 ? (
          <Loader />
        ) : (
          <>
            <h1 className={classes.Adminoffers_main}>Modificare servizi</h1>
            <div className={classes.Adminoffers}>
              <div className={classes.Adminoffers_containet}>
                {this.props.masterList[0][2].map((item, index) => {
                  return (
                    <div className={classes.Adminoffers_edit_block} key={index}>
                      <p>
                        <span>{index + 1}). Servizio: </span>{" "}
                        <input
                          type="text"
                          value={item[0]}
                          alt="0"
                          name={index}
                          onChange={this.changeOfferHandlerEdit}
                        />
                        <span> tempo: </span>
                        <input
                          type="number"
                          value={item[1]}
                          alt="1"
                          name={index}
                          onChange={this.changeOfferHandlerEdit}
                        />
                        <span> costo: </span>
                        <input
                          type="number"
                          value={item[2]}
                          alt="2"
                          name={index}
                          onChange={this.changeOfferHandlerEdit}
                        />
                      </p>
                      <div
                        onClick={this.deleteOfferHandler}
                        style={{
                          width: 20,
                          height: 20,
                          marginLeft: 10,
                          transform: "rotate(45deg)",
                        }}
                      >
                        <img
                          style={{ cursor: "pointer", width: 20, height: 20 }}
                          src={plus}
                          alt={index}
                        />
                      </div>
                    </div>
                  );
                })}
                <hr />
                {this.props.masterList[0][2].length <= 19 ? (
                  <>
                    <h3>Creazione di un nuovo servizio</h3>
                    <div className={classes.Adminoffers_add}>
                      <div className={classes.Adminoffers_add_block}>
                        servizio:{" "}
                        <input
                          value={this.state.offer}
                          onChange={this.changeOfferHandlerAdd}
                        />{" "}
                      </div>
                      <div className={classes.Adminoffers_add_block}>
                        tempo:{" "}
                        <input
                          value={this.state.time}
                          onChange={this.changeTimeHandlerAdd}
                        />{" "}
                      </div>
                      <div className={classes.Adminoffers_add_block}>
                        costo:{" "}
                        <input
                          value={this.state.price}
                          onChange={this.changePriceHandlerAdd}
                        />{" "}
                      </div>

                      <div
                        onClick={this.sendOfferHandler}
                        style={{ width: 30, height: 30 }}
                      >
                        <img
                          style={{ cursor: "pointer", width: 30, height: 30 }}
                          src={plus}
                          alt="add"
                        />
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    masterList: state.masterList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTotalMasterList: (arr) => dispatch(setTotalMasterList(arr)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Adminoffers);
